<template>
  <svg
    :width="width ? width : 81"
    :height="width ? width : 81"
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.4876 29.7742C63.744 14.8607 48.6197 5.80584 33.7063 9.54946C22.0518 12.4751 13.5893 22.5479 12.7174 34.5322C4.44219 35.8969 -1.15996 43.7114 0.204713 51.9866C1.41784 59.3434 7.79241 64.731 15.2483 64.7014H27.9032V59.6395H15.2483C9.65711 59.6395 5.12445 55.1068 5.12445 49.5156C5.12445 43.9244 9.65711 39.3917 15.2483 39.3917C16.6462 39.3917 17.7793 38.2586 17.7793 36.8607C17.7667 24.2804 27.9549 14.0717 40.5353 14.0592C51.4254 14.0483 60.8 21.7472 62.9066 32.4315C63.1146 33.4983 63.9803 34.3133 65.0579 34.4563C71.9772 35.4416 76.7875 41.8496 75.8023 48.7688C74.9176 54.982 69.6127 59.6082 63.3368 59.6395H53.2129V64.7014H63.3368C73.1216 64.6718 81.0296 56.7157 80.9999 46.931C80.9752 38.786 75.4001 31.707 67.4876 29.7742Z"
      fill="#E5E5E5"
    />
    <path
      d="M38.7611 40.1262L28.6372 50.2501L32.2059 53.8187L38.0271 48.0228V72.2948H43.0891V48.0228L48.885 53.8187L52.4537 50.2501L42.3298 40.1262C41.3425 39.1448 39.7483 39.1448 38.7611 40.1262Z"
      fill="#777FF6"
    />
  </svg>
</template>
<script>
export default {
  name: "FileInputIcon",
  props: {width: Number, height:Number}
};
</script>
